import HistoryIcon from 'src/app/assets/icons/ico-history.svg'
import ChartBarIcon from 'src/app/assets/icons/ico-chart-bar.svg'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { useGetCurrentGame } from 'src/store/game'
import { isMarbleGame } from 'src/types/domain/Game'
import { isCrashGameType } from 'src/utils/gameTypeUtils'
import { Button } from '../../Button'

type Props = Readonly<{
  openRightSidebar: (tab: 'betHistory' | 'pastRaces' | 'stats') => void
  /** Toggles the recent-form popover. Owned by the page rather than here:
   *  this rail renders twice (mobile and desktop), so local state would put
   *  two popovers on screen at once. */
  onToggleStats?: () => void
  isStatsOpen?: boolean
}>

export default function ActionsPane({ openRightSidebar, onToggleStats, isStatsOpen }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  // Crash wears the darker instrument-glass rail chassis (v45) — the
  // marble games keep the brighter component wash that matches their look.
  const game = useGetCurrentGame()
  const isCrash = isMarbleGame(game) && isCrashGameType(game.track.gameType)

  const openBetHistoryTab = () => {
    openRightSidebar('betHistory')
  }

  return (
    <div className={`actions-pane-buttons ${isCrash ? 'actions-pane-buttons--crash' : ''}`}>
      {onToggleStats && (
        <Button
          aria-label={t('Recent form')}
          aria-pressed={Boolean(isStatsOpen)}
          className={isStatsOpen ? 'is-active' : ''}
          onClick={onToggleStats}
        >
          <ChartBarIcon />
        </Button>
      )}
      <Button aria-label={t('Bet History')} onClick={openBetHistoryTab}>
        <HistoryIcon />
      </Button>
    </div>
  )
}
